import { render, staticRenderFns } from "./UserSubscribers.vue?vue&type=template&id=507aa990&"
import script from "./UserSubscribers.vue?vue&type=script&lang=js&"
export * from "./UserSubscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports